import * as slider from '@zag-js/slider';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track } from 'ripple';

export component RangeSlider() {
	let service = useMachine(slider.machine, {
		id: 'range-slider',
		defaultValue: [10, 60],
	});
	let api = track(() => slider.connect(service, normalizeProps));

	<div {...@api.getRootProps()}>
		<div>
			<label {...@api.getLabelProps()}>{"Quantity"}</label>
			<output {...@api.getValueTextProps()}>
				<b>{@api.value.join(" - ")}</b>
			</output>
		</div>

		<div {...@api.getControlProps()}>
			<div {...@api.getTrackProps()}>
				<div {...@api.getRangeProps()} />
			</div>
			<div {...@api.getThumbProps({ index: 0 })}>
				<input {...@api.getHiddenInputProps({ index: 0 })} />
			</div>
			<div {...@api.getThumbProps({ index: 1 })}>
				<input {...@api.getHiddenInputProps({ index: 1 })} />
			</div>
		</div>
	</div>
}
